import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const SYNCHRONIZED_UPLOAD_TRANSACTION_API_URL = `${API_HOST}/api/synchronizedUploadTransaction`;

function* searchTransactionRecords() {
  yield takeEvery(actions.SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SYNCHRONIZED_UPLOAD_TRANSACTION_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORDS_ENDED });
    }
  });
}
function* searchTransactionRecordLogs() {
  yield takeEvery(actions.SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORD_LOGS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SYNCHRONIZED_UPLOAD_TRANSACTION_API_URL}/log?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORDS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(searchTransactionRecords), fork(searchTransactionRecordLogs)]);
}
